import { PaletteMode } from '@mui/material';
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';

import { KeyValueStore } from '@frontend/utils';

const THEME_MODE_STORAGE_KEY = 'merchant_ui_theme';

export interface ThemeModeContextType {
  mode: PaletteMode;
  setMode: (mode: PaletteMode) => void;
}

const ThemeModeContext = createContext<ThemeModeContextType>(null!);

const isPaletteMode = (value: string | undefined): value is PaletteMode =>
  value === 'light' || value === 'dark';

export const ThemeModeProvider = ({ children }: PropsWithChildren) => {
  const [mode, setModeState] = useState<PaletteMode>('light');

  useEffect(() => {
    KeyValueStore.get(THEME_MODE_STORAGE_KEY).then((stored) => {
      if (isPaletteMode(stored)) {
        setModeState(stored);
      }
    });
  }, []);

  const setMode = (nextMode: PaletteMode) => {
    setModeState(nextMode);
    KeyValueStore.set(THEME_MODE_STORAGE_KEY, nextMode);
  };

  return (
    <ThemeModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ThemeModeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeModeContext);
